module.exports = __webpack_public_path__ + "img/1f63b.faf99ba.svg";